/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Card from 'shared/ui/components/Card.vue';

/**
 * Component for showing the progress of event related tasks like creation and restore.
 *
 * @vue-prop {String} title modal title
 * @vue-prop {Number} progress modal progress
 * @vue-prop {Boolean} is modal closable?
 *
 * @category ui.components.wizards
 * @exports EventProgress
 */
const __vue_script__ = {
    name: 'EventProgress',

    components: { Card },

    props: {
        title: {
            type: String,
            required: true
        },

        progress: {
            type: Number,
            required: true
        },

        closable: {
            type: Boolean,
            default: false
        },

        hideCards: {
            type: Boolean,
            default: false
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-progress modal-wrapper"},[_c('div',{staticClass:"modal-header"},[(_vm.closable)?_c('span',{staticClass:"close",on:{"click":function () { return _vm.$emit('close'); }}}):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"modal-body"},[(!_vm.hideCards)?_c('div',{staticClass:"listing-grid cards-listing"},_vm._l((3),function(i){return _c('card',{key:i,attrs:{"media":_vm.$utils.assets.imagePath(_vm.$t(("wizards.create_workspace.cards.card-" + i + ".media"))),"link":_vm.$t(("wizards.create_workspace.cards.card-" + i + ".link-url")),"target":"_blank"},scopedSlots:_vm._u([{key:"content",fn:function(ref){return [_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.cards.card-" + i + ".title"))))]),_c('small',{staticClass:"sub"},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.cards.card-" + i + ".description"))))]),_c('a',{staticClass:"more",attrs:{"href":_vm.$t(("wizards.create_workspace.cards.card-" + i + ".link-url")),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.cards.card-" + i + ".link-label"))))])]}}],null,true)})}),1):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.creation_progress')))]),_c('progress-bar',{attrs:{"progress":_vm.progress}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventProgress.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__